/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Onedata_Create_Space_SummaryInputs */



/**
* | output |
* | --- |
* | "Create dataset space {name}" |
*
* @param {Chat_Onedata_Create_Space_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_create_space_summary = /** @type {((inputs: Chat_Onedata_Create_Space_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Create_Space_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Datensatz-Space ${i?.name} erstellen`)
	return /** @type {LocalizedString} */ (`Create dataset space ${i?.name}`)
});